<template>
  <div class="health-list-empty">
    <span class="health-list-empty__icon">
      <OmtIcons
        :name="icon"
        size="2x"
        color="var(--colors-light-primary-navy-blue)"
      />
    </span>
    <OmtTypography
      as="h2-bold"
      class="health-list-empty__title"
    >
      {{ title }}
    </OmtTypography>
    <OmtTypography
      v-if="text"
      as="p1"
      class="health-list-empty__text"
    >
      {{ text }}
    </OmtTypography>
  </div>
</template>

<script>
/**
 * Estado vazio (ou de erro) das listagens de saude.
 * @prop { String } icon
 * @prop { String } title
 * @prop { String } text
 */
export default {
  name: "HealthListEmpty",
  props: {
    icon: { type: String, default: "heartbeat" },
    title: { type: String, required: true },
    text: { type: String, default: "" }
  }
};
</script>

<style scoped>
.health-list-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  padding: 40px 16px;
}

.health-list-empty__icon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #ffffff;
  border: 1px solid var(--colors-light-secondary-divider);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.health-list-empty__title {
  color: var(--colors-light-primary-navy-blue) !important;
  margin: 0;
}

.health-list-empty__text {
  color: var(--colors-light-primary-gray1) !important;
  margin: 8px 0 0;
  max-width: 320px;
}
</style>
